import { clearContentRequested } from 'features/application/actions';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* clearContentSaga(action: ReturnType<typeof clearContentRequested>) {
  const { payload } = action;

  yield call(SignalingSocket.send, {
    event: 'clearContent',
    data: {
      publicChat: payload.publicChat,
      roomLibrary: payload.roomLibrary,
      sharedFiles: payload.sharedFiles,
      whiteboards: payload.whiteboards,
      sharedNotes: payload.sharedNotes,
      qa: payload.qa,
      pollResults: payload.pollResults,
      quizResults: payload.pollResults,
    },
  });
}
